export default "__VITE_ASSET__BWqf3jCy__"